import { render, staticRenderFns } from "./club-calendar-points.vue?vue&type=template&id=4351a3c8&"
import script from "./club-calendar-points.vue?vue&type=script&lang=js&"
export * from "./club-calendar-points.vue?vue&type=script&lang=js&"
import style0 from "./club-calendar-points.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4351a3c8')) {
      api.createRecord('4351a3c8', component.options)
    } else {
      api.reload('4351a3c8', component.options)
    }
    module.hot.accept("./club-calendar-points.vue?vue&type=template&id=4351a3c8&", function () {
      api.rerender('4351a3c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/club-calendar-points.vue"
export default component.exports